import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QualityControlViewApiService } from '../../../../views/quality-control/api/view.service';
import { RoutingService } from '../../../../core/services/routing.service';
import { Department } from '../../../../api/elite/types/department';
import { FilterDepartmentApiService } from '@dep/filters/api';
import { map, switchMap } from 'rxjs/operators';
import { SchedulerSubWorkOrder } from '../../../../common/scheduler/models/sub-work-order';
import { FilterSubWorkOrder, FilterWorkOrder } from '@dep/filters/models';
import { InspectionApiDto } from '../../../../api/elite/dto/inspection.dto';

@Injectable({
  providedIn: 'root',
})
export class FiltersQualityControlViewApiService extends QualityControlViewApiService {
  protected readonly apiDepartmentRouter = inject(FilterDepartmentApiService);
  protected readonly routingService = inject(RoutingService);

  getDepartment(): Observable<Department> {
    return this.apiDepartmentRouter.getDataV2();
  }

  data(): Observable<FilterWorkOrder[]> {
    return this.getDepartment().pipe(
      switchMap((dep) => {
        const query = new URLSearchParams({
          stage: 'Quality Control',
          quantityOut: 'true',
          includeInspection: 'true',
        });
        return this.subWorkOrderApiRoute
          .getByTypeAndStage(dep.id, query.toString())
          .pipe(
            map((res: SchedulerSubWorkOrder[]) => {
              return this.transformItemToWorkOrder(res);
            })
          );
      })
    );
  }

  protected override transformItemToWorkOrder(
    res: SchedulerSubWorkOrder[]
  ): FilterWorkOrder[] {
    return res.map((el) => {
      const item = FilterSubWorkOrder.transformToWorkOrder(el);
      item.inspections = item.inspections.filter((i) => i.details?.fromStageId);
      if (item.currentInspection?.details?.sourceMachineId) {
        item.currentInspection = item.inspections.length ? item.inspections[0] : undefined;
      }
      return item;
    });
  }

  override finishInspection(
    inspectionId: number,
    notes?: string,
    body?: InspectionApiDto['finish']['body']
  ): Observable<InspectionApiDto['finish']['result']> {
    return this.apiInspectionRouter.finishInspection(inspectionId, notes, {
      ...body,
      ifSucessSendTo: 'Filter Packing',
    });
  }
}
